import styled from 'styled-components';
import { ButtonProps } from '@sleepunique/types/button-type';

export const ButtonComponent = styled.button<ButtonProps>`
  display: inline-flex;
  color: var(--color-base-white);
  gap: 1.125rem;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  padding: var(--spacing-1);
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  transition: 0.3s;
  background-color: transparent;
  border: none;
`;

export const IconContainer = styled.div`
  color: var(--color-base-white);
  margin-left: 1.125rem;
  display: flex;
`;
